'use strict';

var GridEntityDeleteModalDirective = function GridEntityDeleteModalDirective() {
  return {
    restrict: 'E',
    template: require('../templates/grid-entity-delete-modal.html'),
    controller: 'GridToolbarConfigurationEntityController',
    link: function link($scope, element) {
      $scope.showModal = function (dataToRemove) {
        $scope.dataToRemove = dataToRemove;
        element.modal('show');
      };
      $scope.yesClicked = function () {
        $scope.$emit('configuration-entity:removeEntity', $scope.dataToRemove);
      };
    }
  };
};
GridEntityDeleteModalDirective.$inject = [];
module.exports = GridEntityDeleteModalDirective;